window.useNewTealium = true;
const initAnalytics = () => {
    (function (t, a, g, m, e) {
        a = 'https://tags.tiqcdn.com/utag/lbg/code/prod/utag.sync.js';
        m = 'script';
        e = t.createElement(m);
        e.src = a;
        e.type = `text/java${m}`;
        e.async = true;
        g = t.getElementsByTagName(m)[0];
        g.parentNode.insertBefore(e, g);
    })(document);
    (function (w) {
        w.runAnalytics = function (t, a, g) {
            a = 'LBGAnalytics';
            g = '_onAnalyticsReady';
            if (w[a] && w[a].data) {
                t(w[a]);
            }
            else {
                w[g] = w[g] || [];
                w[g].push(t);
            }
        };
    })(window);
};
export default initAnalytics;
//# sourceMappingURL=initAnalytics.js.map